window.location.replace("https://tool.investedbetter.com/advisor-match-quiz?utm_source=investedbetter_website&utm_medium=organic&utm_campaign=advisor_match&utm_content=tool_button");


window.addEventListener('heyflow-init', (event) => {
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r: (r & 0x3 | 0x8);
        return v.toString(16);
    });
    
      const flowContainer = document.querySelector(`[flow-id="${event.detail.flowID}"]`);
    const shadowRoot = flowContainer?.shadowRoot || document;
    
    shadowRoot.querySelector('[data-variable="uuid"]').value = uuid;
    
  
    const submitButton =  shadowRoot.querySelector('section[name="phonenumber"]').querySelector('.submit');
    submitButton.disabled = true;
    submitButton.classList.add("disable-button");
    
    // submitButton.style.backgroundColor = "#ccc";// Gray background
    // submitButton.style.cursor = "not-allowed"; // No pointer cursor
    // Setup verification process
    setTimeout(() => {
  const element = shadowRoot.querySelector('input[data-label="Phone Number"]');

  if (element) {
    setupVerification(shadowRoot);
  }
}, 4000);
    
});

const API_BASE_URL = 'https://p.investedbetterplatform.com';
const headers = {
    'Content-Type': 'application/json',
};

// Track verification state
let verificationInProgress = false;
let verificationComplete = false;



function setupVerification(root) {

    const phoneInput = root.querySelector('input[data-label="Phone Number"]')
    const containerMain = root.querySelector('hey-phone-number')
   
    root.querySelector('hey-phone-number  > div > div').classList.add("custom-container")
     const containerVerif = root.querySelector('.custom-container')
    const verificationContainer = document.createElement('div');
    verificationContainer.className = 'verification-container';
    containerMain.parentNode.insertBefore(verificationContainer, phoneInput.nextSibling);
    
    // Add initial verify button
    const verifyPhoneBtn = document.createElement('button');
    verifyPhoneBtn.textContent = 'Verify';
    verifyPhoneBtn.className = 'verification-button';
    containerVerif.appendChild(verifyPhoneBtn);
    
 const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  svg.setAttribute('width', '20');
  svg.setAttribute('height', '20');
  svg.setAttribute('fill', 'currentColor');
  svg.setAttribute('viewBox', '0 0 256 256');

  // Create the child elements of the SVG
  const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  rect.setAttribute('width', '20');
  rect.setAttribute('height', '20');
  rect.setAttribute('fill', 'none');

  const line1 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
  line1.setAttribute('x1', '200');
  line1.setAttribute('y1', '56');
  line1.setAttribute('x2', '56');
  line1.setAttribute('y2', '200');
  line1.setAttribute('fill', 'none');
  line1.setAttribute('stroke', 'currentColor');
  line1.setAttribute('stroke-linecap', 'round');
  line1.setAttribute('stroke-linejoin', 'round');
  line1.setAttribute('stroke-width', '24');

  const line2 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
  line2.setAttribute('x1', '200');
  line2.setAttribute('y1', '200');
  line2.setAttribute('x2', '56');
  line2.setAttribute('y2', '56');
  line2.setAttribute('fill', 'none');
  line2.setAttribute('stroke', 'currentColor');
  line2.setAttribute('stroke-linecap', 'round');
  line2.setAttribute('stroke-linejoin', 'round');
  line2.setAttribute('stroke-width', '24');

  // Append the elements to the SVG
  svg.appendChild(rect);
  svg.appendChild(line1);
  svg.appendChild(line2);
  
   const backBtn = document.createElement('button');
    backBtn.className = 'verification-button';
    backBtn.type='button'
    backBtn.style.display = 'none';
   
  backBtn.appendChild(svg);
  
   containerVerif.appendChild(verifyPhoneBtn);
 containerVerif.appendChild(backBtn);
  // Create the span element
 
  
    // Create verification code elements (initially hidden)
    const codeContainer = document.createElement('div');
    codeContainer.className = 'code-verification-container';
    codeContainer.style.display = 'none';
    
    const codeInput = document.createElement('input');
    codeInput.type = 'text';
    codeInput.placeholder = 'Enter verification code';
    codeInput.className = 'verification-code-input';
    
    const verifyCodeBtn = document.createElement('button');
    verifyCodeBtn.textContent = 'Verify';
    verifyCodeBtn.className = 'submit-button';
    
    codeContainer.appendChild(codeInput);
    codeContainer.appendChild(verifyCodeBtn);
    verificationContainer.appendChild(codeContainer);
    
     const textSpan = document.createElement('span');
  textSpan.className = 'custom-error';
  textSpan.style.display = 'none';

  // Append the error box to the body (or another container)
  verificationContainer.appendChild(textSpan);
    
    backBtn.addEventListener('click', async () => {
     
           const submitButton =  root.querySelector('section[name="phonenumber"]').querySelector('.submit');
    submitButton.disabled = true;
    submitButton.classList.add("disable-button");
                codeContainer.style.display = 'none';
                verifyPhoneBtn.style.display = 'flex';
                backBtn.style.display = 'none';
                verificationInProgress = false;
                verificationComplete = false;
           
      
    });
    
    // Handle initial verification request
    verifyPhoneBtn.addEventListener('click', async () => {
        const phoneNumber = phoneInput.value;
       
        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/verify/phone/initiate`, {
                method: 'POST',
                headers,
                body: JSON.stringify({ phoneNumber })
            });
            
            
            if (response.status === 201) {
                // Show code verification section
                codeContainer.style.display = 'flex';
                verifyPhoneBtn.style.display = 'none';
                backBtn.style.display = 'flex';
                verificationInProgress = true;
            } 
        } catch (error) {
            console.error('Error initiating verification:', error);
        }
    });
 
    // Handle code verification
    verifyCodeBtn.addEventListener('click', async () => {
         
        const phoneNumber = phoneInput.value;
        const code = codeInput.value;
      
        
        
        if (!code) {
           
            
             const errorElement = root.querySelector('.custom-error');
        errorElement.textContent = 'Please enter the verification code';
        errorElement.style.display = 'block';
            
            return;
        }
        
        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/verify/phone/verify`, {
                method: 'POST',
                headers,
                body: JSON.stringify({ 
                    phoneNumber,
                    code
                })
            });
             const data = await response.json();
            
            
            if (data.verified) {
                verificationComplete = true;
                 const submitButton =  root.querySelector('section[name="phonenumber"]').querySelector('.submit');
                 submitButton.disabled = false;
                 submitButton.classList.remove("disable-button")
                  const errorElement = root.querySelector('.custom-error');
 
             errorElement.style.display = 'none';
                // submitButton.style.background = "#008b00"; // Green background
                // // submitButton.style.color = "white"; // White text color
                // submitButton.style.cursor = "pointer"; 
                // Disable inputs after successful verification
                phoneInput.name = 'phone_number';
                phoneInput.value = phoneNumber
                codeInput.disabled = true;
                verifyCodeBtn.disabled = true;
                // Add verified status to form data
                const verifiedField = document.createElement('input');
                verifiedField.type = 'hidden';
                verifiedField.name = 'phoneVerified';
                verifiedField.value = 'true';
                root.querySelector('form').appendChild(verifiedField);
               
            } else {
                // alert();
                 const errorElement = root.querySelector('.custom-error');
        errorElement.textContent = 'Invalid verification code';
        errorElement.style.display = 'block';
                
            }
        } catch (error) {
            console.error('Error verifying code:', error);
           
            
        //     const errorElement = document.querySelector('.custom-error');
        // errorElement.textContent = 'Failed to verify code';
        // errorElement.style.display = 'block';
        }
    });
    
    
}

